import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5039262"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "prmotion-pop-root" }
const _hoisted_2 = { class: "prmotion-pop-content" }
const _hoisted_3 = { class: "pager-wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "page-1"
}
const _hoisted_5 = {
  key: 1,
  class: "page-2"
}
const _hoisted_6 = { class: "page-indicator" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "close-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.promoActivepage === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "view-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('view-details', 1)))
              }, _toDisplayString(_ctx.t('loby.viewdetails')), 1)
            ]))
          : (_ctx.promoActivepage === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: "view-btn",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('view-details', 2)))
                }, _toDisplayString(_ctx.t('loby.viewdetails')), 1)
              ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: _normalizeClass(["p1", { active: _ctx.promoActivepage === 1 }]),
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
          }, null, 2),
          _createElementVNode("div", {
            class: _normalizeClass(["p2", { active: _ctx.promoActivepage === 2 }]),
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
          }, null, 2)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["btn-left", { disabled: _ctx.promoActivepage === 1 }]),
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["btn-rigth", { disabled: _ctx.promoActivepage === 2 }]),
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
      }, null, 2)
    ])
  ]))
}